import { ArticleCardElementsOrientation } from "@config/articleCard";

export type LayoutSlot = {
  index: number;
  orientation?: ArticleCardElementsOrientation;
  className?: string;
  imgWidth?: number;
  imgHeight?: number;
};

export const STARTING_DESKTOP_LAYOUT: LayoutSlot[] = [
  {
    index: 0,
    orientation: "vertical-summary",
    className: "col-start-2 col-span-2 row-start-1 row-span-2",
    imgWidth: 581,
    imgHeight: 398.92,
  },
  {
    index: 1,
    className: "col-start-1 row-start-1",
  },
  {
    index: 2,
    className: "col-start-4 row-start-1",
  },
  {
    index: 3,
    className: "col-start-1 row-start-2",
  },
  {
    index: 4,
    className: "col-start-4 row-start-2",
  },
];

export const STARTING_TABLET_LEFT: LayoutSlot[] = [
  { index: 0, orientation: "vertical-summary" },
  { index: 1 },
];

export const STARTING_TABLET_RIGHT: LayoutSlot[] = [
  { index: 2 },
  { index: 3 },
  { index: 4 },
];

export type ColumnItem =
  | { type: "article"; index: number }
  | { type: "topics" }
  | { type: "alert" }
  | { type: "ads" }
  | { type: "empty" };

export const LAYOUT_ONE_DESKTOP_COLUMNS: ColumnItem[][] = [
  [
    { type: "article", index: 0 },
    { type: "article", index: 2 },
  ],
  [
    { type: "topics" },
    // { type: "alert" }, Disable alert block for now.
    { type: "article", index: 3 },
  ],
  [
    { type: "article", index: 1 },
    { type: "article", index: 4 },
  ],
];
export const LAYOUT_ONE_TABLET_COLUMNS: ColumnItem[][] = [
  [
    { type: "article", index: 0 },
    { type: "article", index: 1 },
    { type: "article", index: 3 },
  ],
  [
    { type: "topics" },
    // { type: "alert" }, Disable alert block for now.
    { type: "article", index: 2 },
    { type: "article", index: 4 },
  ],
];

export const LAYOUT_TWO_ARRANGEMENT: LayoutSlot[] = [
  {
    index: 0,
    className: "col-start-1 row-start-1",
  },
  {
    index: 1,
    className: "col-start-2 row-start-1",
  },
  {
    index: 2,
    className: "col-start-1 lg:col-start-3 row-start-2 lg:row-start-1",
  },
  {
    index: 3,
    className: "col-start-2 lg:col-start-1 row-start-2",
  },
  {
    index: 4,
    className: "col-start-1 lg:col-start-2 row-start-3 lg:row-start-2",
  },
  {
    index: 5,
    className: "col-start-2 lg:col-start-3 row-start-3 lg:row-start-2",
  },
];
